const classes = {
    AppLayout: {
        position: "relative",
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        width: '90%',
        justifyContent: 'space-between',
        minHeight: '100Vh',
        margin: 'auto',
    },
    decorLine: {
        width: "100%",
        height: "78px",
        position: "absolute",
        left: "0",
        top: "0",
        boxShadow: "0px 4px 12px rgba(207, 207, 207, 0.25)",
    }
};

export default classes;